import i18n from 'i18next';

export default ({ isDisabled }) => ({
  cover_art: {
    type: 'Upload',
    uploadType: 'image',
    permittedFormats: 'image/*',
    hasReplaceUploadButton: true,
    replaceUploadButtonText: i18n.t('replace-cover-art'),
    uploadButtonText: i18n.t('add-cover-art'),
    removeButtonText: i18n.t('remove-cover-art'),
    maxUploadSize: 10,
    hasIcon: true,
    iconPosition: 'left',
    icon: 'addImage',
    buttonSize: 'small',
    isDisabled,
  },
});
